'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".LocalDeliveryMap-module_loadingContainer__2UO-Z{align-items:center;display:flex;justify-content:center}.LocalDeliveryMap-module_mapContainer__6d-qA{position:relative}.LocalDeliveryMap-module_timestamp__KvG-V{background-color:hsla(0,0%,100%,.7);bottom:0;left:0;padding:0 1rem;position:absolute;z-index:10}.LocalDeliveryMap-module_refreshText__HW1An{color:#fff;font-family:Poppins;font-size:14px;font-weight:700;line-height:20px;margin:1rem 0 0}";
var styles = {"loadingContainer":"LocalDeliveryMap-module_loadingContainer__2UO-Z","mapContainer":"LocalDeliveryMap-module_mapContainer__6d-qA","timestamp":"LocalDeliveryMap-module_timestamp__KvG-V","refreshText":"LocalDeliveryMap-module_refreshText__HW1An"};
styleInject["default"](css_248z, '447b7f6a-8c18-47cb-ba06-a0de211dbc8a');

exports["default"] = styles;
